module.exports = __webpack_public_path__ + "static/iCloud_2-89de423c4373d4c9a7de82a342c2f221.png";